var React = require('react');

function MenuIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"menu-icon"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"menu-icon","fill":"#F37D5A","fillRule":"nonzero"},[React.createElement("polygon",{"id":"Path","points":"0 0 18 0 18 2 0 2","key":0}),React.createElement("polygon",{"id":"Path","points":"0 7 18 7 18 9 0 9","key":1}),React.createElement("polygon",{"id":"Path","points":"0 14 18 14 18 16 0 16","key":2})]))]);
}

MenuIcon.defaultProps = {"width":"18px","height":"16px","viewBox":"0 0 18 16","version":"1.1"};

module.exports = MenuIcon;

MenuIcon.default = MenuIcon;
